import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";

import ItemsSkeleton from "../../../components/loaders/ItemsSkeleton";
import {useTranslation} from "react-i18next";
import ProductCard from "./components/ProductCard";
import {Link, useNavigate} from "react-router-dom";
import {Pagination} from "@mui/lab";
import {Button} from "@mui/material";
import ListFilters from "../../manage/lists/filters/ListFilters";
import {isAdmin, isSupplier} from "../../../../config/Permissions";
import Box from '@mui/material/Box';
import {CirclePlus, RefreshCw} from 'lucide-react';
import Title from "../../../components/elements/Title";
import {AddBox} from "@mui/icons-material";
import {scrollTop} from "../../../../config/values";
import {connect} from "trim-redux";



function ProductsPage({isApp}){
    const { t } = useTranslation();
    const [items, setItems] = useState([]);
    const [filters, setFilters] = useState({});
    const [pages, setPages] = useState(1);
    const [current_page, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const navigation = useNavigate();

    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        const url = `${defaultVariables.url}/products/${isAdmin() ? "get-all" : "get-mine"}?page=${current_page}${!!filters.text ? "&search="+filters.text : ''}${!!filters.industry ? "&industry="+filters.industry : ''}`;
        axios.get(url,config)
            .then(response => {
                setItems(response.data.data);
                setPages(response.data.last_page);
                setCurrentPage(response.data.current_page);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
            });
    }

    useEffect(() => {
        loadData();
        scrollTop();
    },[current_page]);

    useEffect(() => {
        loadData();
        scrollTop();
    },[filters]);

    const handleChange = (event, value) => {
        setCurrentPage(value);
    };
    const handleFilter = (filters) => {
        setFilters(filters);
    }

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageProducts')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12} className="flex-space">
                    {
                        !isApp &&
                            <Title align="left" color="text" className="panel-title">{t('manageProducts')}</Title>
                    }
                    {
                        isSupplier() &&
                        <Button
                            size="small"
                            color="primary"
                            variant="outlined"
                            component={Link}
                            to={'/panel/vendor/products/bulk-edit'}
                        >
                            {t('editPrices')}
                        </Button>
                    }
                </Grid>
                {
                    !!loading ?
                        <>
                            <ItemsSkeleton height={100} xs={12} md={12} lg={12} length={1}/>
                            <ItemsSkeleton height={200} xs={6} md={4} lg={3}/>
                        </>
                        :
                        <>
                            <Grid item size={12}>
                                <ListFilters
                                    filters={['search',isAdmin() && 'industries']}
                                    onFilter={handleFilter}
                                    has_bg
                                />
                            </Grid>

                            <Grid item size={12} >
                                <Grid container spacing={2} justify="center">
                                    <Grid item size={{xs:12,md:4,lg:3}}>
                                        <Box component="section" className={!isApp && "addItemBtnHolder"}>
                                            <Button
                                                variant={"contained"}
                                                color="secondary"
                                                size="small"
                                                startIcon={<AddBox/>}
                                                className={"addItemBtn"}
                                                component={Link}
                                                to={`/panel/${isAdmin() ? 'manage' : "vendor"}/products/add`}
                                            >
                                                {t('addProduct')}
                                            </Button>
                                        </Box>

                                    </Grid>
                                    {
                                        items.map((item,index) =>(
                                            <Grid item size={{xs:6,md:4,lg:3}} key={index}>
                                                <ProductCard item={item} reload={() => loadData()}/>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                            {
                                pages > 1 &&
                                <Grid item size={12}>
                                    <Pagination
                                        shape="rounded"
                                        count={pages}
                                        page={current_page}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            }

                        </>
                }
            </Grid>
        </AppAnimate>
    );
}
const mstp = (state) => ({
    isApp: state.isApp,
});

export default withStyles(Styles)(connect(mstp)(ProductsPage));
